import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme, Text } from 'react-native-paper';
import { AccountHealthData } from './AccountHealthData';
const Title = ({ title, testID, style }) => {
    const theme = useTheme();
    const styles = StyleSheet.create({
        headerTitle: {
            fontSize: 40,
            fontWeight: 'bold',
            lineHeight: 30,
            marginVertical: 2,
            letterSpacing: 0.15,
            color: theme.colors.primary,
            alignSelf: 'center',
        },
    });
    return (_jsx(Text, { testID: `${testID}-default-title`, style: [styles.headerTitle, style], children: title }));
};
const SubTitle = ({ title, testID, style }) => {
    if (typeof title === 'string') {
        return (_jsx(Text, { variant: 'titleMedium', testID: `${testID}-default-sub-title`, style: [{ textAlign: 'center', marginVertical: 10 }, style], children: title }));
    }
    return title;
};
export const ConnectHealthData = forwardRef(({ testID = 'connect-health-data', title = 'Connect My Health Data', subTitle = 'All fields are required unless noted.', ...rest }, ref) => {
    return (_jsxs(View, { testID: `${testID}-container`, children: [_jsx(Title, { testID: `${testID}-title`, title: title, style: rest.titleStyle }), _jsx(SubTitle, { testID: `${testID}-sub-title`, title: subTitle, style: rest.subTitleStyle }), _jsx(AccountHealthData, { ref: ref, testID: `${testID}-account-health-data`, ...rest })] }));
});
